var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-bubble-wrapper" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.validateMessage,
            expression: "validateMessage"
          }
        ],
        staticClass:
          "product-bubble offer-price-bubble offer-price-validate-bubble"
      },
      [_vm._v("\n    " + _vm._s(_vm.validateMessage) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.bubbleMessage && !_vm.validateMessage,
            expression: "bubbleMessage && !validateMessage"
          }
        ],
        staticClass:
          "product-bubble offer-price-bubble offer-price-warning-bubble"
      },
      [_vm._v("\n    " + _vm._s(_vm.bubbleMessage) + "\n  ")]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "currency",
          rawName: "v-currency",
          value: {
            currency: null,
            locale: "ja",
            precision: 0,
            distractionFree: false
          },
          expression:
            "{currency: null, locale: 'ja', precision: 0, distractionFree: false}"
        },
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayValue,
          expression: "displayValue"
        },
        {
          name: "validate",
          rawName: "v-validate",
          value: _vm.validation,
          expression: "validation"
        }
      ],
      ref: "input",
      staticClass: "form-control text-right",
      style: _vm.customStyle,
      attrs: { type: "text", name: "money" },
      domProps: { value: _vm.displayValue },
      on: {
        blur: _vm.showBubble,
        focus: function($event) {
          _vm.isInputActive = true
        },
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.displayValue = $event.target.value
          },
          _vm.handleInput
        ]
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bae4a17e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bae4a17e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/ProductInputMoney.vue
// module id = null
// module chunks = 